var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (displayKind, enableAggregations, item) {
buf.push("<a class=\"mlsb-suggestion\">");
if (!( enableAggregations))
{
buf.push("<span class=\"mlsb-suggestion-thumbnail\"><span class=\"mlsb-suggestion-fallback\"><img" + (jade.attr("src", item.imageUrl(), true, true)) + " width=\"32\" height=\"32\" onerror=\"this.style.display=&quot;none&quot;;\"></span></span>");
}
if ( item.get('displayHeading'))
{
buf.push("<div class=\"tt-suggestion-category\">" + (jade.escape(null == (jade_interp = item.get('category')) ? "" : jade_interp)) + "</div>");
}
buf.push("<span class=\"mlsb-suggestion-value\"><span class=\"mlsb-suggestion-display\">" + (jade.escape(null == (jade_interp = item.get('display')) ? "" : jade_interp)) + "</span>");
if ( item.get('model') && displayKind)
{
buf.push("<em class=\"mlsb-suggestion-kind\">" + (jade.escape(null == (jade_interp = item.get('display_model')) ? "" : jade_interp)) + "</em>");
}
buf.push("</span></a>");}.call(this,"displayKind" in locals_for_with?locals_for_with.displayKind:typeof displayKind!=="undefined"?displayKind:undefined,"enableAggregations" in locals_for_with?locals_for_with.enableAggregations:typeof enableAggregations!=="undefined"?enableAggregations:undefined,"item" in locals_for_with?locals_for_with.item:typeof item!=="undefined"?item:undefined));;return buf.join("");
};
module.exports = template;